import React, { useState, useEffect } from 'react';
import './Contact.css';

const Contact = () => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    phone: '',
    company: '',
    subject: '',
    message: ''
  });

  const [isSubmitting, setIsSubmitting] = useState(false);
  const [submitStatus, setSubmitStatus] = useState(null);

  useEffect(() => {
    if (window.location.hash === '#book-appointment-form') {
      const formSection = document.getElementById('book-appointment-form');
      if (formSection) {
        const yOffset = -90; // Offset for fixed navbar
        const y = formSection.getBoundingClientRect().top + window.pageYOffset + yOffset;
        window.scrollTo({ top: y, behavior: 'smooth' });
      }
    }
  }, []);

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);
    
    // Simulate form submission
    setTimeout(() => {
      setIsSubmitting(false);
      setSubmitStatus('success');
      setFormData({
        name: '',
        email: '',
        phone: '',
        company: '',
        subject: '',
        message: ''
      });
      
      // Reset status after 5 seconds
      setTimeout(() => setSubmitStatus(null), 5000);
    }, 2000);
  };

  return (
    <div className="contact page-transition">
      {/* Hero Section */}
      <section className="contact-hero">
        <div className="container">
          <div className="contact-hero-content">
            <h1>Contact Us</h1>
            <p>Get in touch to discuss how we can help your business grow</p>
          </div>
        </div>
      </section>

      {/* Contact Information */}
      <section className="section contact-info">
        <div className="container">
          <div className="grid grid-3">
            <div className="contact-card">
              <div className="contact-icon">
                <svg width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                  <path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"></path>
                  <polyline points="22,6 12,13 2,6"></polyline>
                </svg>
              </div>
              <h3>Email Us</h3>
              <p>info@prosperitypartners.net</p>
            </div>
            
            <div className="contact-card">
              <div className="contact-icon">
                <svg width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                  <path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z"></path>
                </svg>
              </div>
              <h3>Call Us</h3>
              <p>416-577-8744</p>
            </div>
            
            <div className="contact-card">
              <div className="contact-icon">
                <svg width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                  <path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z"></path>
                  <circle cx="12" cy="10" r="3"></circle>
                </svg>
              </div>
              <h3>Location</h3>
              <p>Toronto, Canada</p>
            </div>
          </div>
        </div>
      </section>

      {/* Contact Form */}
      <section className="section contact-form-section" id="book-appointment-form">
        <div className="container">
          <div className="grid grid-2">
            <div className="form-content">
              <h2>Book Your Appointment</h2>
              <p>
                Ready to transform your business? Fill out the form below and we'll get back to you 
                within 24 hours to schedule your consultation.
              </p>
              
              <form onSubmit={handleSubmit} className="contact-form">
                <div className="form-group">
                  <label htmlFor="name">Full Name *</label>
                  <input
                    type="text"
                    id="name"
                    name="name"
                    value={formData.name}
                    onChange={handleChange}
                    required
                  />
                </div>
                
                <div className="form-group">
                  <label htmlFor="email">Email Address *</label>
                  <input
                    type="email"
                    id="email"
                    name="email"
                    value={formData.email}
                    onChange={handleChange}
                    required
                  />
                </div>
                
                <div className="form-group">
                  <label htmlFor="phone">Phone Number</label>
                  <input
                    type="tel"
                    id="phone"
                    name="phone"
                    value={formData.phone}
                    onChange={handleChange}
                  />
                </div>
                
                <div className="form-group">
                  <label htmlFor="company">Company Name</label>
                  <input
                    type="text"
                    id="company"
                    name="company"
                    value={formData.company}
                    onChange={handleChange}
                  />
                </div>
                
                <div className="form-group">
                  <label htmlFor="subject">Subject *</label>
                  <select
                    id="subject"
                    name="subject"
                    value={formData.subject}
                    onChange={handleChange}
                    required
                  >
                    <option value="">Select a subject</option>
                    <option value="consultation">Business Consultation</option>
                    <option value="strategic-planning">Strategic Planning</option>
                    <option value="business-development">Business Development</option>
                    <option value="financial-advisory">Financial Advisory</option>
                    <option value="operational-excellence">Operational Excellence</option>
                    <option value="other">Other</option>
                  </select>
                </div>
                
                <div className="form-group">
                  <label htmlFor="message">Message *</label>
                  <textarea
                    id="message"
                    name="message"
                    value={formData.message}
                    onChange={handleChange}
                    rows="5"
                    required
                    placeholder="Tell us about your business and how we can help..."
                  ></textarea>
                </div>
                
                <button 
                  type="submit" 
                  className={`btn btn-primary ${isSubmitting ? 'loading' : ''}`}
                  disabled={isSubmitting}
                >
                  {isSubmitting ? 'Sending...' : 'Send Message'}
                </button>
                
                {submitStatus === 'success' && (
                  <div className="success-message">
                    Thank you! Your message has been sent successfully. We'll get back to you within 24 hours.
                  </div>
                )}
              </form>
            </div>
            
            <div className="contact-details">
              <h3>Get in Touch</h3>
              <p>
                We're here to help you achieve your business goals. Whether you need strategic planning, 
                business development, or operational improvements, our team is ready to assist you.
              </p>
              
              <div className="contact-method">
                <h4>Email</h4>
                <p>info@prosperitypartners.net</p>
              </div>
              
              <div className="contact-method">
                <h4>Phone</h4>
                <p>416-577-8744</p>
              </div>
              
              <div className="contact-method">
                <h4>Location</h4>
                <p>Toronto, Ontario, Canada</p>
              </div>
              
              <div className="contact-method">
                <h4>Business Hours</h4>
                <p>Monday - Friday: 9:00 AM - 6:00 PM EST</p>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Contact; 